import { CarouselLabels } from '../../components/CarouselLabels';
import { useOfferContext } from '../OfferContext';

interface IOwnProps {
  href: string;
}

export function LabelsContainer({ href }: IOwnProps) {
  const { photoLabels } = useOfferContext();

  /**
   * Для случаев, когда эл. торги включены, лейбл "Залоговая недвижимость, аукцион" необходимо убрать.
   * требования по старым условиям для лейблов в задаче CD-143469
   */
  const labels = [...(photoLabels || [])];

  if (!labels.length) {
    return null;
  }

  return <CarouselLabels labels={labels} offerHref={href} />;
}
